module.exports = __webpack_public_path__ + "img/BG.d50fb411.svg";